// IMPORT PACKAGE REFERENCES
import React from 'react';

// COMPONENT
export class SmallPlus extends React.Component {
    render() {
        return (
            <div>
                <div className='small-plus float noselect'>
                    <img className='small-plus-image' src={require('../../images/plus.png')} />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/containers/SmallPlus.js